// extracted by mini-css-extract-plugin
module.exports = {"base":"VideoPlayback_base__P8QJ1"};